import { RoundedBox } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import { COLORS } from "../../../constants/colors";

const RoundedBoxComponent = ({
  position = [0, 0, 0],
  size = 0.8,
  radius = 0.2,
  mass = 0.0001,
  friction = 3,
  restitution = 1,
  linearDamping = 1,
  angularDamping = 0,
  color = COLORS.kubes,
}) => {
  return (
    <RigidBody
      mass={mass}
      friction={friction}
      restitution={restitution}
      linearDamping={linearDamping}
      angularDamping={angularDamping}
      colliders="cuboid"
      rotationConstraints={{ x: false, y: false, z: false }}
      position={position}
    >
      <RoundedBox args={[size, size, size]} radius={radius}>
        <meshPhysicalMaterial
          color={color}
          metalness={0.5}
          roughness={0.9}
          reflectivity={0.1}
        />
      </RoundedBox>
    </RigidBody>
  );
};

export default RoundedBoxComponent;
